<template>
  <LayoutSection
    :sectionClass="sectionClass"
    :paddingClass="paddingClassComputed"
    :maxWidthClass="maxWidthClass"
  >
    <div class="flex items-center justify-between">
      <h4 class="text-black text-[2.4rem] font-semibold" v-safe-html="title"></h4>
      <a
        v-if="showViewAll"
        :href="link"
        class="text-black text-right font-medium underline hover:opacity-60"
      >
        {{ $t("View all") }}
      </a>
    </div>

    <slot></slot>
  </LayoutSection>
</template>

<script>
import LayoutSection from "@/components/design/layoutSection.vue";

export default {
  name: "BaseAllArticles",
  components: {
    LayoutSection,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      required: true,
    },
    sectionClass: {
      type: String,
      required: false,
      default: "",
    },
    maxWidthClass: {
      type: String,
      required: false,
      default: "max-w-[1100px] mx-auto",
    },
  },
  computed: {
    paddingClassComputed() {
      return undefined;
    },
  },
};
</script>

<style scoped></style>
